// extracted by mini-css-extract-plugin
export var closeButton = "smoke-module--close-button--c5bed";
export var container = "smoke-module--container--fc8a3";
export var contentBox = "smoke-module--content-box--24e38";
export var iconBox = "smoke-module--icon-box--8450c";
export var link = "smoke-module--link--d1777";
export var logoBox = "smoke-module--logo-box--56731";
export var text = "smoke-module--text--8a578";
export var titleText = "smoke-module--title-text--734d6";
export var unread = "smoke-module--unread--a6906";